import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */
import Select from '../../../../components/select';
import disp from './dispOptions';

class TabNav extends React.PureComponent {
    static propTypes = {
        // content: PropTypes.object,
        onChange: PropTypes.func,
        onDispChange: PropTypes.func,
    };

    state = {
        content: [
            {
                title: '全部股票',
            },
            {
                title: '科创板',
            },
        ],
        curIndex: 0,
        disps: disp,
    };

    componentDidMount = () => {
        this.props.onChange(this.state.curIndex);
    };

    handleSwitch = index => {
        this.setState(
            {
                curIndex: index,
            },
            () => {
                this.props.onChange(index);
            },
        );
    };

    handleDispChange = val => {
        this.props.onDispChange(val.value);
    };

    render() {
        const { disps, curIndex } = this.state;

        return (
            <div className={styles.tab}>
                {this.state.content.map((item, index) => {
                    return (
                        <div
                            href={item.url}
                            onClick={this.handleSwitch.bind(this, index)}
                            className={`${styles.tabItem} ${index === curIndex ? styles.active : ''}`}
                            key={index}>
                            {item.title}
                        </div>
                    );
                })}
                <div className={styles.select}>
                    申报状态：
                    <Select
                        defaultValue={{ label: '全部状态', value: 0 }}
                        options={disps}
                        styles={{ float: 'right', marginTop: 7 }}
                        onChange={this.handleDispChange}
                    />
                </div>
            </div>
        );
    }
}

export default TabNav;
